import { CheckCircle } from '@phosphor-icons/react'

import { formatTimeRange } from '@/utils/date/format-time-range'

import DropdownDots from '../../DropdownDots/DropdownDots'
import { formatDateTime, formatPermissions } from '../utils'
import StatusPill from '../components/StatusPill'
import { APP_COLORS } from '../../../helpers/constants'

export const getVendorColumns = (
  t,
  onCheckInClick,
  onDetailsClick,
  onBanToggle,
  onSuspendToggle,
  timezone,
) => [
  {
    Header: t('visitors:columns.vendorName'),
    accessor: 'vendorName',

    Cell: ({ row }) => {
      const name = row.original.name
      const phone = row.original.phone

      return (
        <div className="vendor-name-cell">
          <div>{name}</div>
          {phone && <div className="additional-info">{phone}</div>}
        </div>
      )
    },
  },
  {
    Header: t('visitors:columns.permissions'),
    accessor: 'permissions',

    Cell: ({ row }) => {
      const permission = formatPermissions(row.original, timezone)
      const permissionTime = formatTimeRange(row.original.startTime, row.original.endTime, timezone)
      return (
        <div className="permission-cell">
          <div>{permission}</div>
          <div className="permission-time">{permissionTime}</div>
        </div>
      )
    },
  },
  {
    Header: t('visitors:columns.lastCheckIn'),
    accessor: 'lastCheckIn',

    Cell: ({ row }) => {
      if (!row.original.lastCheckIn) {
        return <div>-</div>
      }

      const { date, time } = formatDateTime(row.original.lastCheckIn, timezone)
      return (
        <div className="last-check-in-cell">
          <div>{date}</div>
          <div className="check-in-time">{time}</div>
        </div>
      )
    },
  },
  {
    Header: t('visitors:columns.permissionToEnter'),
    accessor: 'permissionToEnter',

    Cell: ({ row }) => (
      <div className="permission-to-enter">
        {row.original.permissionToEnter ? <CheckCircle size={18} /> : null}
      </div>
    ),
  },
  {
    Header: t('visitors:columns.coi'),
    accessor: 'coi',

    Cell: ({ row }) => (
      <div className="coi">{row.original.coi ? <CheckCircle size={18} /> : null}</div>
    ),
  },
  {
    Header: t('visitors:columns.status'),
    accessor: 'status',

    Cell: ({ row }) => <StatusPill status={row.original.status} />,
  },
  {
    Header: t('visitors:columns.actions'),
    accessor: 'actions',

    Cell: ({ row }) => (
      <div className="actions" onClick={(e) => e.stopPropagation()}>
        {/* Disable check-in if vendor is banned or expired */}
        <button
          className="button button-transparent"
          onClick={() => onCheckInClick(row.original)}
          disabled={row.original.status !== 'active'}
        >
          {t('visitors:columns.checkIn')}
        </button>
        <DropdownDots
          options={[
            {
              id: 1,
              text: t('visitors:columns.details'),
              action: () => onDetailsClick(row.original),
            },
            {
              id: 2,
              text: row.original.banned ? t('visitors:columns.unban') : t('visitors:columns.ban'),
              styleContainer: { background: APP_COLORS.red100 },
              styleText: { color: APP_COLORS.red500 },
              action: () => onBanToggle(row.original),
            },
            {
              id: 3,
              text: row.original.suspended
                ? t('visitors:columns.unsuspend')
                : t('visitors:columns.suspend'),
              action: () => onSuspendToggle(row.original),
            },
          ]}
        />
      </div>
    ),
  },
]
